import React from 'react';

const Star = () => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.993 12.474">
		<path className="fill" d="M15.638,11.919l4.355.845-3.033,3.269.551,4.441-4.015-1.9-4.015,1.9.551-4.441L7,12.763l4.355-.845L13.5,8Z" transform="translate(-7 -8)" />
	</svg>
)

export default Star;